import {
  OAuthIntegrationPairingModal
} from './OAuthIntegrationPairingModal';
import {
  honeybookService
} from "../services/api";
import {
  OnboardingEvents
} from '../analytics/posthog';

interface HoneyBookPairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  existingLabels?: string[];
}

export function HoneyBookPairingModal({
  isOpen,
  onClose,
  onSuccess,
  existingLabels,
}: HoneyBookPairingModalProps) {
  return (
    <OAuthIntegrationPairingModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingLabels={existingLabels}
      name="honeybook"
      displayName="HoneyBook"
      description="Connect your HoneyBook account so your assistant can look up clients, projects, and invoices, and keep contact details up to date."
      features={[
        'Look up clients, projects, and their history',
        'See which invoices are still unpaid or overdue',
        'Add and update contacts and project details',
        'Answer questions about your bookings and paperwork',
      ]}
      accentColor="orange"
      events={{
        modalOpened: OnboardingEvents.HONEYBOOK_MODAL_OPENED,
        oauthStarted: OnboardingEvents.HONEYBOOK_OAUTH_STARTED,
        connected: OnboardingEvents.HONEYBOOK_CONNECTED,
        connectionFailed: OnboardingEvents.HONEYBOOK_CONNECTION_FAILED,
        modalClosed: OnboardingEvents.HONEYBOOK_MODAL_CLOSED,
      }}
      service={honeybookService}
    />
  );
}
